import { useEffect, useRef } from 'react'

import {
  useInterview,
  useRegenerateShortTranscript,
} from '@/react-query/interview/interview'

export const useAutoGenerateShortTranscript = () => {
  const interview = useInterview().data
  const regenerate = useRegenerateShortTranscript()
  const triggeredForInterviewId = useRef<string | null>(null)

  useEffect(() => {
    if (!interview?.id) return
    if (interview.shortTranscript) return
    if (!interview.fullTranscript) return
    if (interview.isFullTranscriptGenerating) return
    if (regenerate.isPending) return
    if (triggeredForInterviewId.current === interview.id) return

    triggeredForInterviewId.current = interview.id
    regenerate.mutate()
  }, [
    interview?.id,
    interview?.shortTranscript,
    interview?.fullTranscript,
    interview?.isFullTranscriptGenerating,
    regenerate,
  ])
}
